import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sanitizeUrl' })
export class SanitizeUrlPipe implements PipeTransform {

  constructor(private domSanitizer: DomSanitizer) { }

  /* transform(): Pipe que devuelve URL de forma segura (proporcionado por angular), para inyectar código correctamente
    value: fragmento URL
  */
  transform = (value: string): SafeUrl => this.domSanitizer.bypassSecurityTrustUrl(value);

}
